import React from "react";

const Footer = () => {
  return (
  <>
    <section className="section contact-section" role="contentinfo">
      <hr className="separator" />
      <div className="contact-info">
        <div>マイページに関するお問い合わせ</div>
        <div className="tel-text" aria-label="電話番号 0120-41-8504">
          <a href="tel:0120-41-8504">0120-41-8504</a>
        </div>
        <div>受付時間：平日9：00～17：00</div>
      </div>
    </section>
  </>
  );
};

export default Footer;
